import {TRANSFORM_TYPE} from "utils/constants";

export const changeTransform = transform => ({
  type: TRANSFORM_TYPE.CHANGE_TRANSFORM,
  payload: transform,
});

export const turnOnSnapMode = () => ({
  type: TRANSFORM_TYPE.SNAP_ON,
});

export const turnOffSnapMode = () => ({
  type: TRANSFORM_TYPE.SNAP_OFF,
});

export const setSnapProperty = snapProperty => ({
  type: TRANSFORM_TYPE.SET_SNAP_PROPERTY,
  payload: snapProperty,
});
